import React, { useState, useEffect, useRef } from 'react';
import { BrowserBarcodeReader } from '@zxing/library';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import QrCodeIcon from '@mui/icons-material/QrCode';
import './App.css'; // Import the CSS file
import { Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';


function Scanner() {
  const [barcode, setBarcode] = useState('');
  const [barcodeDetails, setBarcodeDetails] = useState(null);

  const [scanning, setScanning] = useState(false);
  const scannerContainerRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (scanning) {
      startScanner();
    }
  }, [scanning]);

  const startScanner = () => {
    const codeReader = new BrowserBarcodeReader();
    const scannerContainer = scannerContainerRef.current;
    const videoElement = videoRef.current;

    if (!scannerContainer) {
      console.error('Scanner container element not found.');
      return;
    }

    if (!videoElement) {
      console.error('Video element not found.');
      return;
    }

    codeReader
      .decodeFromVideoElement(videoElement, 'video')
      .then((result) => {
        console.log('Detected barcode:', result.text);
        setBarcode(result.text);
        setScanning(false);
      })
      .catch((error) => {
        console.error('Error:', error);
      });

    codeReader
      .listVideoInputDevices()
      .then((videoInputDevices) => {
        if (videoInputDevices.length > 0) {
          codeReader.decodeFromInputVideoDevice(videoInputDevices[0].deviceId, 'video');
        } else {
          console.error('No video input devices found.');
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };

  // const handleButtonClick = () => {
  //   setBarcode('');
  //   setScanning(true);
  // };

  const fetchBarcodeDetails = (barcode) => {
    // Replace this with your own implementation to fetch the barcode details
    return new Promise((resolve, reject) => {
      // Simulating an API call with a delay
      setTimeout(() => {
        const barcodeDetails = {
          name: 'Product 1',
          price: 'R9.99',
          category: 'Beer',
        };
        resolve(barcodeDetails);
      }, 1000);
    });
  };

  
  const handleButtonClick = () => {
    if (barcode) {
      // Perform search based on the barcode value and set the barcode details
      // Replace the fetchBarcodeDetails function with your own implementation
      fetchBarcodeDetails(barcode)
        .then((details) => {
          setBarcodeDetails(details);
        })
        .catch((error) => {
          console.error('Error fetching barcode details:', error);
        });
    } else {
      setScanning(true);
    }
  };
  
  return (
    <div className="scanner-container">
      {scanning ? (
        <div>
          <p>The barcode scanned is: {barcode}</p>
        </div>
      ) : (
        <div className="scanner">
          <Box
            className="scanner-box"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              maxWidth: '400px',
              padding: '20px',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
              borderRadius: '4px',
              backgroundColor: '#ffffff',
              width: '90%', // Adjust the width as needed for responsiveness
            }}
          >
            <TextField
              label="Enter barcode"
              value={barcode}
              onChange={(e) => setBarcode(e.target.value)}
              variant="outlined"
              size="large"
              className="barcode-input"
            />
            <Button
              variant="contained"
              onClick={handleButtonClick}
              size="large"
              className="scan-button"
              startIcon={<QrCodeIcon />}
            >
              {barcode ? 'Search Barcode' : 'Use Scanner'}
            </Button>
          </Box>
          {barcode && <p className="input-barcode">The input barcode is: {barcode}</p>}
        </div>
      )}

{barcodeDetails && (
  <Table className="custom-table">
    <TableHead>
      <TableRow>
        <TableCell>Barcode</TableCell>
        <TableCell>Name</TableCell>
        <TableCell>Price</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow className="table-row">
        <TableCell>{barcode}</TableCell>
        <TableCell>{barcodeDetails.name}</TableCell>
        <TableCell>{barcodeDetails.price}</TableCell>
      </TableRow>
    </TableBody>
  </Table>
)}


      <div className="video-container" ref={scannerContainerRef}>
        <video
          id="video"
          ref={videoRef}
          className="video-element"
          autoPlay
          playsInline
        ></video>
      </div>
    </div>
  );
}

export default Scanner;
